import { FiltersSelected, FilterProps } from "@usereactify/search";
import React, { useRef, useState, useEffect } from "react";
import { useOnClickOutside } from "../../../hooks/useOnClickOutside";

type FilterListProps = {
  isSidePanel: boolean;
  filterListProps: React.ComponentProps<NonNullable<FilterProps["renderFilterList"]>>;
};


export const FilterList: React.FC<FilterListProps> = ({ filterListProps, isSidePanel }) => {
  const [open, setOpen] = useState<boolean>(false);
  const filterClasses = `thb-filter-dropdown ${open ? "active-facets" : ""}`;
  
  const ref = useRef<HTMLDivElement>(null);
  useOnClickOutside(ref, () => setOpen(false));

  const handleOpen = () => {
    setOpen((prev) => !prev);
  };

  useEffect(() => {
    // listen for the esc key and close the filter
    const handleEsc = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        setOpen(false);
      }
    };

    if (window) {
      window.addEventListener("keydown", handleEsc);
    }

    return () => {
      if (window) {
        window.removeEventListener("keydown", handleEsc);
      }
    }
  }, []);
  
  return (
    <div ref={ref} className="facets">
      <div className="thb-filter">
        <button onClick={handleOpen}>
          <span className="thb-filter-title">
            {filterListProps.filter.name}
            {!isSidePanel && (
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M20 8L12 16L4 8"
                  stroke="#2B2B2B"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            )}
          </span>
        </button>
        <div  className={filterClasses}>
          <div className="thb-filter-dropdown__inner">
            <ul>
              {filterListProps.filterListProps.options.map(({ key, label, checked }) => (
                <li key={key}>
                  <label className="">
                    <input
                      type="checkbox"
                      value={label}
                      checked={checked}
                      onChange={(event) => filterListProps.filterListProps.handleChange(event.target.value)}
                    />
                    <span className="" style={{textTransform: "uppercase"}}>{label}</span>
                  </label>
                </li>
              ))}
            </ul>
          </div>
          <div className="thb-filter-dropdown__footer">
            <FiltersSelected
              render={(renderProps) => {
                const totalActive = renderProps.selectedFilters.find(
                  (selectedFilter) => selectedFilter.key === filterListProps.filter.handle
                )?.value?.length;
                return (
                  <div className="facets__selected">{`${totalActive !== undefined ? totalActive : "0"} selected`}</div>
                );
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
